/**
 * Customers icon: target audience.
 * Uses the provided customers/target audience icon image.
 */
export default function CustomersIcon({ size = 20, style = {} }) {
  return (
    <img
      src="/icons/customers-icon.png"
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0, objectFit: 'contain', imageRendering: '-webkit-optimize-contrast', ...style }}
    />
  );
}
